<template>
  <el-row
    type="flex"
    justify="center"
    align="middle"
    class="App-Page-H"
    :gutter="20"
  >
    <el-col :xs="24" :sm="22" :md="19" :lg="16" :xl="14">
      <div class="App-Page-H-C">
        <el-space w-100 :fill="true" alignment="center" direction="vertical">
          <!-- Logo -->
          <div class="App-Page-H-L" txt-center>
            <app-logo :size="32"></app-logo>
          </div>
          <!-- Main Form H -->
          <div class="App-Page-H-M">
            <div class="App-Page-H-Max">
              <slot></slot>
            </div>
          </div>
          <!-- Footer -->
          <div class="App-Page-H-F" txt-center>
            <app-footer></app-footer>
          </div>
          <!--  -->
        </el-space>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Options, Vue } from "vue-class-component";

@Options({
  name: "App-Pageholder",
  components: {},
})
export default class extends Vue {}
</script>

<style lang="scss">
.App-Page-H {
  min-height: 99vh;
  width: 100%;
  margin: auto !important;
  max-width: 100%;
  // Container
  .App-Page-H-C {
    min-height: 300px;
  }
  // White part for form holding
  &-M {
    min-height: 450px;
    background: $--color-white;
    box-shadow: map.get($--box-shadow, "light");
    min-width: 350px;
    max-width: 460px;
    border-radius: map.get($--border-radius, "large");
    padding: map.get($--button-padding-vertical, "large")
      map.get($--button-padding-vertical, "large") * 1.5
      map.get($--button-padding-vertical, "large") * 1.5
      map.get($--button-padding-vertical, "large") * 1.5;
    margin: auto;
  }
  .App-Page-H-Max {
    max-width: 350px;
    margin: auto;
  }

  //
  // App-Page-H-M forms
  .App-Page-H-M .el-form {
  }
}
</style>
